
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
	name: 'SkeletonLoader',
})
/**
 * Simple building block for skeleton loaders
 *
 * Expectations for usage:
 * 1) A custom class will be added, containing an explicit height and width at minimum
 * OR
 * 2) It will be the child of an element with a defined height and width.
 *
 * This component was derived from an existing loader implementation (.grey-skeleton-loader), but
 * is more straightforward to use, ie. does not require children with specific classname.
 */
class SkeletonLoader extends Vue {
}

export default SkeletonLoader;
